import en_US from "./en_US"
import el_GR from "./el_GR";
// 准备翻译的语言环境信息
const local = {
    en_US,
    el_GR
}

export default local;
